document.addEventListener('click', function (event) {
  var swatch = event.target.closest('.vw-swatch');
  if (!swatch) return;

  console.log('[vw] swatch clicked', swatch);

  var card = swatch.closest('.card-wrapper');
  console.log('[vw] card found:', card);
  if (!card) return;

  var variantInput = card.querySelector('.product-variant-id');
  console.log('[vw] variantInput found:', variantInput);
  if (!variantInput) return;

  var variantId = swatch.getAttribute('data-variant-id');
  console.log('[vw] variantId:', variantId);
  if (!variantId) return;

  event.preventDefault();
  console.log('[vw] preventDefault called, proceeding');

  var variantImage = swatch.getAttribute('data-variant-image');
  var available = swatch.getAttribute('data-variant-available') === 'true';

  variantInput.value = variantId;

  var images = card.querySelectorAll('.vw-card-image');
  if (images.length && variantImage) {
    images.forEach(function (img) {
      img.src = variantImage;
      img.srcset = variantImage;
    });
  }

  var button = card.querySelector('product-form button[type="submit"]');
  if (button) {
    button.disabled = !available;
    var label = button.querySelector('.vw-btn-label');
    if (label) {
      label.textContent = available
        ? label.getAttribute('data-add-label')
        : label.getAttribute('data-sold-out-label');
    }
  }

  card.querySelectorAll('.vw-swatch').forEach(function (s) {
    s.style.outline = '';
  });
  swatch.style.outline = '2px solid #1d1d1f';
});